export default {
  phone: "string",
  email: "string",
  logo_image: "object",
  managers: ["hasMany", "user"],
}
